/**
 * Clamp the long .rental-object-description text on a Vitec rental object
 * (lägenhet) page to a fixed height on mobile, with a fade-out and a
 * "Läs mer" / "Läs mindre" toggle link.
 *
 * Mobile only — desktop is left completely untouched. Only applied when the
 * text actually overflows the clamped height; short descriptions are left as-is.
 */

const MOBILE_QUERY = '(max-width: 767px)';
const CLAMP_CLASS = 'rental-object-description--clamped';
const TOGGLE_CLASS = 'rental-object-description__toggle';

function setupRentalDescription(desc) {
	const mq = window.matchMedia(MOBILE_QUERY);
	let toggle = null;

	if (!desc.id) {
		desc.id = 'rental-object-description';
	}

	function teardown() {
		desc.classList.remove(CLAMP_CLASS);
		if (toggle) {
			toggle.remove();
			toggle = null;
		}
	}

	function setup() {
		if (toggle || !mq.matches) {
			return;
		}

		desc.classList.add(CLAMP_CLASS);

		if (desc.scrollHeight <= desc.clientHeight + 1) {
			desc.classList.remove(CLAMP_CLASS);
			return;
		}

		toggle = document.createElement('button');
		toggle.type = 'button';
		toggle.className = TOGGLE_CLASS;
		toggle.textContent = 'Läs mer';
		toggle.setAttribute('aria-expanded', 'false');
		toggle.setAttribute('aria-controls', desc.id);

		toggle.addEventListener('click', function () {
			const expanding = desc.classList.contains(CLAMP_CLASS);
			desc.classList.toggle(CLAMP_CLASS, !expanding);
			toggle.textContent = expanding ? 'Läs mindre' : 'Läs mer';
			toggle.setAttribute('aria-expanded', expanding ? 'true' : 'false');

			if (!expanding) {
				desc.scrollIntoView({ block: 'nearest' });
			}
		});

		desc.insertAdjacentElement('afterend', toggle);
	}

	function onChange() {
		if (mq.matches) {
			setup();
		} else {
			teardown();
		}
	}

	if (mq.addEventListener) {
		mq.addEventListener('change', onChange);
	} else {
		mq.addListener(onChange);
	}

	setup();
}

function init() {
	document.querySelectorAll('.rental-object-description').forEach(setupRentalDescription);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
